/* eslint-disable no-unused-vars */
import Vue from "vue";
import _ from "lodash";
import { TOKEN_EXPIRED } from "../auth/store/mutations-types.js";
import { ACTION_TYPES, MUTATION_TYPES } from "./store_keys.js";

// ie RestModule("http://localhost:8000/api/code_example/");

function handleError(err, commit) {
    if (err.response && err.response.status == 401) {
        // We are no longer logged in!

        commit("AuthModule/" + TOKEN_EXPIRED, null, { root: true });
    }
}

export function CreatePreferences(api) {
    return {
        namespaced: true,
        state: {
            global: [],
            user: [],

            global_by_identifier: {},
            user_by_identifier: {},

            working: false,
        },
        mutations: {
            set_global(state, items) {
                state.global = items;
                state.global_by_identifier = _.keyBy(items, "identifier");
            },
            set_user(state, items) {
                state.user = items;
                state.user_by_identifier = _.keyBy(items, "identifier");
            },
            [MUTATION_TYPES.START_WORKING](state) {
                state.working = true;
            },
            [MUTATION_TYPES.FINISH_WORKING](state) {
                state.working = false;
            },
        },
        actions: {
            [ACTION_TYPES.GET_ALL](
                { rootGetters, dispatch, commit },
                list_options = {},
            ) {
                return new Promise((resolve, reject) => {
                    if (rootGetters["AuthModule/isLoggedIn"]) {
                        dispatch("AuthModule/refreshToken", null, {
                            root: true,
                        });

                        commit(MUTATION_TYPES.START_WORKING);

                        Vue.axios
                            .get(api + "/api/ocom/prefs/global/", {})
                            .then((response) => {
                                commit(MUTATION_TYPES.FINISH_WORKING);

                                commit("set_global", response.data);
                            })
                            .catch((err) => {
                                commit(MUTATION_TYPES.FINISH_WORKING);

                                handleError(err, commit);

                                reject(err);
                            });

                        Vue.axios
                            .get(api + "/api/ocom/prefs/user/", {})
                            .then((response) => {
                                commit(MUTATION_TYPES.FINISH_WORKING);

                                commit("set_user", response.data);
                            })
                            .catch((err) => {
                                commit(MUTATION_TYPES.FINISH_WORKING);

                                handleError(err, commit);

                                reject(err);
                            });
                    }
                });
            },
        },
        getters: {
            global_preferences(state) {
                return state.global_by_identifier;
            },
            user_preferences(state) {
                return state.user_by_identifier;
            },
        },
    };
}
